module.exports = __webpack_public_path__ + "static/media/2.21ade77e.jpg";